'use strict';

// Recursive function to sort object keys and array elements
function deepSort(obj) {
    if (Array.isArray(obj)) {
        // Sort array elements
        return obj.map(deepSort).sort();
    } else if (obj !== null && typeof obj === 'object') {
        // Sort object keys
        return Object.keys(obj).sort().reduce((result, key)=>{
            result[key] = deepSort(obj[key]);
            return result;
        }, {});
    }
    // Return the value for non-object types
    return obj;
}

module.exports = deepSort;
